import { motion } from "framer-motion";

export default function IntroOverlay() {
  return (
    <motion.div
      data-testid="intro-overlay"
      initial={{ y: 0 }}
      animate={{ y: "-100%" }}
      transition={{ delay: 1.5, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="pointer-events-none fixed inset-0 z-[100] flex flex-col items-center justify-center bg-navy"
    >
      <motion.div
        initial={{ scale: 0.3, opacity: 0, rotate: -14 }}
        animate={{ scale: 1, opacity: 1, rotate: 0 }}
        transition={{ type: "spring", stiffness: 130, damping: 13, delay: 0.15 }}
        className="overflow-hidden rounded-full border-4 border-royal bg-white"
      >
        <img
          src="/logo.png"
          alt="Gone Today Junk Removal"
          className="h-44 w-44 object-cover sm:h-64 sm:w-64"
        />
      </motion.div>
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.55, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
        className="mt-6 font-mono2 text-[11px] uppercase tracking-[0.4em] text-white/70"
      >
        Gone Today Junk Removal
      </motion.p>
    </motion.div>
  );
}
